import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const Wrapper = styled.div`
  margin: 2rem 0 0 0;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  text-align: left;

  ${themeMedia.desktop`
    width: auto;
  `};
`

export const ImageContainer = styled.div`
  justify-content: center;
  display: flex;
  position: relative;
  z-index: 0;
`
